// ABOUTME: Builds sidepanel deep-link URLs (current route + obfuscated ?sp= param) and the link click handler.
// ABOUTME: Plain left-click runs the in-place open; cmd/ctrl/middle-click lets the browser open a new tab.

import { encodeSidepanel } from './sidepanelCodec';

// Query param that carries the obfuscated descriptor of which panel / tab / id to open.
export const SIDEPANEL_PARAM = 'sp';

// Keeps the user on the current route and appends the obfuscated descriptor. Opening the
// link in a new tab loads the same route and the global host overlays the panel.
export const buildSidepanelUrl = (pathname, key, id, tab) => {
    const d = { k: key, id };
    if (tab !== null && tab !== undefined) d.tab = tab;
    return `${pathname}?${SIDEPANEL_PARAM}=${encodeSidepanel(d)}`;
};

// Returns an onClick that keeps the existing in-place behaviour on a plain left-click but
// steps aside (so the native anchor navigates) on cmd/ctrl/shift/alt or middle-click.
export const makeSidepanelClickHandler = (inPlaceFn) => (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) {
        return; // let the browser open the link (new tab / new window)
    }
    e.preventDefault();
    if (inPlaceFn) inPlaceFn();
};
